import React from "react";
import styled, { keyframes } from "styled-components";
import { size } from "@glossy";

interface IProps {
  size?: Size;
  className?: string;
}

export const SIZES = {
  s: 8,
  m: 12,
};
type Size = keyof typeof SIZES;

const Root = styled.div<Pick<IProps, "size">>`
  display: inline-block;
  position: relative;
  ${(props) => size(SIZES[props.size], SIZES[props.size] * 4)};
`;

const reveal = keyframes`
  from {
    transform: scale(0.001);
  }
  to {
    transform: scale(1);
  }
`;

const slide = (size) => keyframes`
  to {
    transform: translateX(${size});
  }
`;

const Dot = styled.div<Partial<IProps>>`
  ${(props) => size(SIZES[props.size])};
  border-radius: 100%;
  background-color: currentColor;
  position: absolute;
  animation: 0.5s ease infinite;
  &.dot1,
  &.dot2 {
    left: 0;
  }
  &.dot3 {
    left: ${(props) => SIZES[props.size] * 1.5}px;
  }
  &.dot1 {
    animation-name: ${reveal};
  }
  &.dot2,
  &.dot3 {
    animation-name: ${(props) => slide(SIZES[props.size] * 1.5 + "px")};
  }
  &.dot4 {
    left: ${(props) => SIZES[props.size] * 3}px;
    animation-name: ${reveal};
    animation-direction: reverse;
  }
`;

const UiKitLoaderDots = ({ size = "s", className }: IProps) => (
  <Root size={size} className={className}>
    <Dot size={size} className="dot1" />
    <Dot size={size} className="dot2" />
    <Dot size={size} className="dot3" />
    <Dot size={size} className="dot4" />
  </Root>
);

export default UiKitLoaderDots;
